export const adminPortalMock = {
  summary: [
    {
      label: "Leads ativos",
      value: "18",
      detail: "6 novos nas ultimas 48h",
    },
    {
      label: "Clientes em acompanhamento",
      value: "43",
      detail: "11 com atualizacao esta semana",
    },
    {
      label: "Reunioes agendadas",
      value: "9",
      detail: "4 para hoje",
    },
    {
      label: "Documentos pendentes",
      value: "27",
      detail: "12 aguardando envio de clientes",
    },
  ],
  leads: [
    {
      name: "Larissa M. Araujo",
      area: "Familia e sucessoes",
      source: "Landing page",
      status: "Contato inicial",
      priority: "Alta",
      updatedAt: "Hoje, 09:18",
    },
    {
      name: "Bruno F. Nunes",
      area: "Direito civil",
      source: "Indicacao",
      status: "Triagem concluida",
      priority: "Media",
      updatedAt: "Hoje, 10:05",
    },
    {
      name: "Atlas Incorporadora",
      area: "Empresarial",
      source: "Instagram",
      status: "Proposta enviada",
      priority: "Alta",
      updatedAt: "Ontem, 17:42",
    },
    {
      name: "Paula S. Ribeiro",
      area: "Divorcio",
      source: "WhatsApp",
      status: "Aguardando retorno",
      priority: "Media",
      updatedAt: "Ontem, 14:26",
    },
  ],
  clients: [
    {
      name: "Mariana Costa Ribeiro",
      case: "Inventario extrajudicial",
      stage: "Em andamento",
      advisor: "Dra. Ana Carolina Lucena",
      nextAction: "Assinatura de procuracao",
    },
    {
      name: "Henrique L. Vargas",
      case: "Revisao contratual empresarial",
      stage: "Analise documental",
      advisor: "Equipe consultiva",
      nextAction: "Checklist societario",
    },
    {
      name: "Verde Mar Comercio Ltda.",
      case: "Estruturacao societaria",
      stage: "Onboarding",
      advisor: "Dra. Ana Carolina Lucena",
      nextAction: "Envio de contrato social",
    },
  ],
  schedule: [
    {
      time: "09:30",
      title: "Reuniao de alinhamento",
      person: "Larissa M. Araujo",
      mode: "Online",
    },
    {
      time: "11:00",
      title: "Consulta estrategica",
      person: "Atlas Incorporadora",
      mode: "Presencial",
    },
    {
      time: "14:30",
      title: "Atualizacao de caso",
      person: "Mariana Costa Ribeiro",
      mode: "Online",
    },
    {
      time: "16:00",
      title: "Assinatura e documentos",
      person: "Verde Mar Comercio Ltda.",
      mode: "Presencial",
    },
  ],
  alerts: [
    {
      title: "3 leads sem retorno ha mais de 24h",
      detail: "Priorizar contato para nao perder janela de conversao.",
    },
    {
      title: "5 documentos aguardando validacao interna",
      detail: "Revisar antes da liberacao no portal dos clientes.",
    },
    {
      title: "1 parcela vence amanha",
      detail: "Disparar lembrete financeiro e atualizar status da cobranca.",
    },
  ],
  pipeline: [
    {
      stage: "Novos contatos",
      total: 7,
      color: "lead",
    },
    {
      stage: "Triagem",
      total: 5,
      color: "triage",
    },
    {
      stage: "Proposta",
      total: 4,
      color: "proposal",
    },
    {
      stage: "Convertidos",
      total: 2,
      color: "won",
    },
  ],
};
